export var LayoutTypes;
(function (LayoutTypes) {
    LayoutTypes["GRID"] = "grid";
    LayoutTypes["LIST"] = "list";
})(LayoutTypes || (LayoutTypes = {}));
export const DEFAULT_LAYOUT_TYPE = LayoutTypes.GRID;
